import styled from "styled-components";

export const QrCode = styled.img`
  width: 250px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  margin-top: 80px;
`;

export const InfoConnection = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  font-size: 14px;
`;

export const LoadImage = styled.img`
  width: 25px;  
  margin-right: 5px;
  margin-top:5px;
`;

export const ConnectionLink = styled.a`
  display: block;
  margin-top: 16px;
  font-size: 13px;
  color: rgba(0, 255, 194, 0.7);
  text-align: center;
  text-decoration: none;

  &:hover {
    color: #00ffc2;
    text-decoration: underline;
  }
`;

export const FormCreateSession = styled.div`
  width: 380px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`;

export const ToggleRow = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: #ccc;
  user-select: none;
`;

export const ToggleSwitch = styled.input.attrs({ type: "checkbox" })`
  appearance: none;
  width: 44px;
  height: 24px;
  background: #444;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;

  &::before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
  }

  &:checked {
    background: #00ffc2;

    &::before {
      transform: translateX(20px);
    }
  }
`;